import React, { useState } from "react";
import Lottie, { Options, EventListener } from "react-lottie";
import { observer } from "mobx-react";
import { Fade, Typography } from "@material-ui/core";
import { throttle } from "lodash";

import { useStore } from "../../store";
import { setWebBridge } from "../../utils/webBridge";
import { FabContainer, MuiIconButton } from "./style";
import { Icon } from "../../components";
import ALike from "./assets/like.json";
import AUnlike from "./assets/unlinke.json";
import { addLikeCount, deleteLikeCount } from "../../api";
import { convertCount } from "../../utils/convert";
import { getLikeProjects } from "../../utils/storage";
import { languageAr } from "../../utils/Translation";
import firebaseEvent from "../../utils/firebaseEvent";
interface Props {
  likeCounts: number;
  projectId: string;
  dynamicLink: string;
  setLikeCount: (count: number) => void;
}

const DetailItemFab = ({
  likeCounts: count,
  projectId: project_id,
  dynamicLink: dynamic_link,
  setLikeCount,
}: Props) => {
  const {
    appStore: {
      appState: { share, languageCode },
      apiHeaderState: { token },
    },
    feedStore: { onUpdateLikeCounts, onUpdateUnlikeCounts },
    detailStore: {
      infoState: { isMoreInfo },
      onUpdateStart,
    },
  } = useStore();

  const { className } = languageAr(languageCode);
  const [isPauseLottie, setIsPauseLottie] = useState(true);
  const [isLike, setIsLike] = useState(getLikeProjects()?.includes(project_id));
  const [isShare, setIsShare] = useState(true);
  const likeProps = {
    id: project_id,
    token,
  };
  const callLikeApi = throttle((like) => {
    const jsonParams = {
      P1: project_id,
    };
    if (like) {
      //Firebase Event
      firebaseEvent("detail_like", jsonParams);
      addLikeCount(likeProps).then(() => onUpdateLikeCounts(project_id));
    } else {
      //Firebase Event
      firebaseEvent("detail_unlike", jsonParams);
      deleteLikeCount(likeProps).then(() => onUpdateUnlikeCounts(project_id));
    }
  }, 1000);
  const onClickLike = () => {
    if (!isPauseLottie) return;
    setIsPauseLottie(false);
    setLikeCount(isLike ? count - 1 : count + 1);
    callLikeApi(isLike ? false : true);
  };

  const lottieOptions: Options = {
    loop: false,
    autoplay: false,
    animationData: isLike ? AUnlike : ALike,
    // animationData: isLike ? ALike : AUnlike,
  };
  const completeEventListener: EventListener = {
    eventName: "complete",
    callback: () => {
      setIsPauseLottie(true);
      setIsLike(isLike ? false : true);
      //callLikeApi(isLike ? false : true);
    },
  };

  const onClickShare = throttle(() => {
    if (!isShare) return;
    setIsShare(false);
    const req = {
      project_id,
      dynamic_link,
      type: 0,
    };

    const jsonParams = {
      P1: project_id,
      P2: dynamic_link,
    };
    firebaseEvent("detail_share", jsonParams);

    // ios share
    if (typeof navigator.share !== "undefined") {
      setIsShare(true);
      return navigator.share({ url: req.dynamic_link });
    }

    // android share
    try {
      setTimeout(() => {
        setIsShare(true);
      }, 1000);
      return setWebBridge({
        name: "onShareStart",
        args: JSON.stringify(req),
      });
    } catch {
      // on update popup
      setIsShare(true);
      return onUpdateStart("share");
    }
  }, 1000);
  const ShareBtn = () => {
    if (!share) return null;
    return (
      <MuiIconButton onClick={onClickShare}>
        <Icon name="share" size={28} />
      </MuiIconButton>
    );
  };

  return (
    <Fade in={!isMoreInfo}>
      <FabContainer className={className}>
        <MuiIconButton onClick={onClickLike}>
          <Lottie
            width={28}
            height={28}
            options={lottieOptions}
            isPaused={isPauseLottie}
            isClickToPauseDisabled
            eventListeners={[completeEventListener]}
          />
          <Typography component="p" variant="caption">
            {convertCount(count)}
          </Typography>
        </MuiIconButton>
        <ShareBtn />
      </FabContainer>
    </Fade>
  );
};

export default observer(DetailItemFab);
